"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebShellOptimization = void 0;
class WebShellOptimization {
    constructor(locations) {
        this._locations = [];
        if (locations) {
            this._locations = locations;
        }
    }
}
exports.WebShellOptimization = WebShellOptimization;
//# sourceMappingURL=WebShellOptimization.js.map